import React, {Component} from 'react'
import Cannonicalize from '../Cannonicalize'
import ClientSideCacheController from '../ClientSideCacheController'
import Analytics from '../Analytics'

class HomePageTakeover extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    this.state = Cannonicalize.category()
    this.state.banners = Cannonicalize.banner()
    this.categoryId = props.category || 303482
    this.debug = false
  }


  componentWillMount() {
    try {
      this.setState( Cannonicalize.category(this.props.FRN_rawResponses[0].data) )
    } catch (e){
      e.message += ' in HomePageTakeover'
      Analytics.reportError(e)
    }


    if (typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate) 
    ClientSideCacheController.get('category', {id: this.categoryId}).then((res) => {
      this.setState(res)
    })

    ClientSideCacheController.get('banner', {debug: this.debug}).then((res) => {
      this.setState({banners: res})
    })


  }


  render() { // REQUIRED
    try{

      if(this.state.features.length < 2)
        return null

      let backgroundImage = this.state.features[0].abridged.abstractimage.filename + '?width=1280&height=720'
      let mainTitle = this.state.features[0].abridged.headline
      return (<div className='gnm-home-page-takeover'>
        <div className='row  hidden-xs background-image-row' style={{
            backgroundImage: `url('${backgroundImage}')`
          }}>
          <div className='col-sm-7 col-md-8 col-xs-12'>
            <h1 className='main-title'>{mainTitle}</h1>

          </div>
          <div className=' col-sm-5 col-md-4 right-column hidden-xs '>
            <div className='dark-opacity '>
              <div className='right-column-contents'>
                <div className='row'>
                  <div className='col-xs-12'>
                    <a href={this.state.banners.liveUrl} className='watch-live' style={{display: this.state.banners.live ? 'block' : 'none'}}>
                      <span className='watch-live-text'>Watch Live</span>
                      <span className='glyphicon glyphicon-play-circle'/>
                    </a>
                  </div>
                </div>
                {
                  this.state.features.slice(1, 2).map(function(s, i, a) { //in case the array is empty
                    return (<div className='row secondary-story' key={i}>
                      <div className='col-xs-12'>
                        <a href={s.link.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')}>
                          <img className='img-responsive' src={s.abstractimage.filename || ''}/>
                        </a>
                      </div>
                      <div className='col-xs-12 secondary-title-container'>
                        <a href={s.link.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')} className='secondary-title'>
                          <span >{
                              s.headline.replace(/<\/?[^>]+(>|$)/g, "").replace(/&(.*?);/g, ' ')
                              /* we have a problem with literal &nbsp; tags in this string */
                            }</span>
                        </a>
                      </div>
                      <div className='col-sm-12 hidden-sm secondary-subtitle'>
                        <span>{
                            s.abstract.replace(/<\/?[^>]+(>|$)/g, "").replace(/&(.*?);/g, ' ')
                          }</span>
                      </div>
                    </div>)
                  })
                }

                {
                  this.state.features.slice(2, 5).map(function(s, i, a) {
                    return (<div key={i}>
                      <div className='divider visible-sm-block'/>
                      <div className='row related-story '>
                        <div className='col-xs-5 hidden-sm related-stories-photo-col'>
                          <a href={s.link.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')}>
                            <img className='img-responsive' src={s.abstractimage.filename || ''}/>
                          </a>
                        </div>
                        <div className='col-sm-12 col-md-7 related-stories-text-col'>
                          <div className='row'>
                            <div className='col-xs-12'>
                              <a href={s.link.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')} className='related-stories-title'>{s.headline.replace(/<\/?[^>]+(>|$)/g, "")}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)
                  })
                }
              </div>
              <div className='view-more'>
                <div className='row'>
                  <div className='col-xs-12'>
                    <a href={this.props.overflowPage.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')}>
                      <span >More Stories</span>
                      <span className='glyphicon glyphicon-chevron-right'/>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row visible-xs-block dark-opacity xs-bottom-bar related-stories small'>
          <img className="img-responsive" src={backgroundImage}/>
          <div className='col-xs-12'>
            <a href={this.state.banners.liveUrl} className='watch-live' style={{display: this.state.banners.live ? 'block' : 'none'}}>
              <span className='watch-live-text'>Watch Live</span>
              <span className='glyphicon glyphicon-play-circle'/>
            </a>
          </div>
          {
            this.state.features.slice(1, 4).map(function(s, i, a) {
              return (<div key={i} className='col-xs-12 bottom-border'>
                <a href={s.link.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')}>{s.headline.replace(/<\/?[^>]+(>|$)/g, "")}</a>
              </div>)
            })
          }
          <div className='view-more small'>
            <a href={this.props.overflowPage.replace('http://www.newson6.com', '').replace('http://www.news9.com', '')} className='bottom-border'>
              <span >View More</span>
              <span className='glyphicon glyphicon-chevron-right'/>
            </a>
          </div>

        </div>
      </div>)
    } catch(e){
      e.message += ' in HomePageTakeover'
      Analytics.reportError(e)
    }
  }
}

export default HomePageTakeover



// WEBPACK FOOTER //
// ./app/components/custom/ssr/HomePageTakeover/index.js